import { useEffect, useState } from 'react'
import { readRecentlyViewedProducts, trackRecentlyViewedProduct, type RecentlyViewedProduct } from '../../recentlyViewed'
import type { CatalogProduct } from '../../types'

export const useRecentlyViewedProducts = (productData: CatalogProduct | null) => {
  const [recentlyViewedProducts, setRecentlyViewedProducts] = useState<RecentlyViewedProduct[]>(
    readRecentlyViewedProducts().slice(0, 8),
  )

  useEffect(() => {
    trackRecentlyViewedProduct(productData)
    const productId = productData?._id ?? null
    const entries = readRecentlyViewedProducts()
      .filter((entry) => (productId ? entry.id !== productId : true))
      .slice(0, 6)
    setRecentlyViewedProducts(entries)
  }, [productData])

  return recentlyViewedProducts
}
